import { useState } from "react";

import LoadingIndicator from "ds/components/LoadingIndicator";
import { createDrawer, createDrawerTrigger } from "ds/components/DrawerNew/utils";
import Box from "ds/components/Box";
import DrawerForm from "ds/components/DrawerNew/Form";

import { UserManagementActivationStatus } from "../../types";
import useGetGroup from "../useGetGroup";
import EditDrawerContent from "./Content";
import { ManagedUserGroupView } from "../types";

type IdpGroupMappingEditDrawerProps = {
  currentGroup?: ManagedUserGroupView;
  activationStatus: UserManagementActivationStatus;
};

const IdpGroupMappingEditDrawer = createDrawer(
  ({ currentGroup, activationStatus }: IdpGroupMappingEditDrawerProps) => {
    const [isDirty, setIsDirty] = useState(false);
    const { group, loading, error } = useGetGroup({
      id: currentGroup?.id,
    });

    if (error) {
      return null;
    }

    return (
      <DrawerForm isDirty={isDirty}>
        {loading && (
          <Box grow="1" justify="center" align="center">
            <LoadingIndicator size="x-large" loading />
          </Box>
        )}
        {group && !loading && (
          <EditDrawerContent
            setIsDirty={setIsDirty}
            group={group}
            activationStatus={activationStatus}
          />
        )}
      </DrawerForm>
    );
  }
);

export const showIdpGroupMappingEditDrawer = createDrawerTrigger(IdpGroupMappingEditDrawer);
